import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { userRoutes } from "./Routes/AllRoutes";
import NonAuthLayout from "./Routes/middleware/NonAuthLayout";
import ScrollToTop from "./Components/Utils/ScrollToTop";
import CookieConsent from "./Components/Utils/CookieConsent";

const App = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}
        </Routes>
        
        <CookieConsent />
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
